/**
 * Encodes a JavaScript object into a URL-safe string.
 * @param obj The object to encode.
 * @returns A base64 encoded string representation of the object.
 */
export function encodeObjectForUrl(obj: any): string {
    if (obj === null || typeof obj !== 'object') {
        return "";
    }
    try {
        const jsonString = JSON.stringify(obj);
        return btoa(jsonString);
    } catch (e) {
        console.error("Failed to encode object for URL:", e);
        return "";
    }
}

/**
 * Decodes a URL-safe string back into a JavaScript object.
 * @param encoded The base64 encoded string.
 * @returns The decoded object, or null if decoding fails.
 */
export function decodeObjectFromUrl(encoded: string): any | null {
    if (!encoded) {
        return null;
    }
    try {
        const jsonString = atob(encoded);
        return JSON.parse(jsonString);
    } catch (e) {
        console.error("Failed to decode object from URL:", e);
        return null;
    }
}
